<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="mb-0">Resultados</h5>
        <div>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="$emit('refresh')"
          >
            Atualizar
          </b-button>
        </div>
      </div>

      <b-table
        :items="normalized"
        :fields="fields"
        small
        responsive
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center text-muted py-3">Carregando...</div>
        </template>

        <!-- Período -->
        <template #cell(period)="data">
          <code>{{ data.item.periodLabel }}</code>
        </template>

        <!-- Qtd Uso (centralizado) -->
        <template #cell(count)="data">
          <div class="text-center">{{ data.item.count }} usos</div>
        </template>

        <!-- Qtd Horas (direita) -->
        <template #cell(net)="data">
          <div class="text-right text-end">
            {{ data.item.hoursLabel || formatHoursLabel(data.item.net) }}
          </div>
        </template>

        <!-- Faturamento -->
        <template #cell(amount)="data">
          <div class="text-right text-end">
            {{ formatBRL(data.item.amount) }}
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'PeriodReportList',
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  computed: {
    normalized() {
      return (this.items || []).map((it) => {
        const periodMinutes = Number(it.periodTime ?? 0)
        const periodLabel =
          it.periodTimeLabel ||
          (Number.isFinite(periodMinutes) ? `${periodMinutes} min` : '-')
        const count = Number(it.quantia ?? 0)
        const net = Number(it.hours ?? 0) // horas decimais
        const hoursLabel = it.hoursLabel || null
        const amount = Number(it.amount ?? 0)

        return {
          periodLabel,
          period: periodMinutes,
          count,
          net,
          hoursLabel,
          amount
        }
      })
    },
    fields() {
      return [
        {
          key: 'period',
          label: 'Período',
          thClass: 'text-left text-start',
          tdClass: 'text-left text-start',
          formatter: (_v, _k, item) => item.periodLabel
        },
        {
          key: 'count',
          label: 'Qtd Uso',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'net',
          label: 'Tempo de Uso',
          thClass: 'text-right text-end',
          tdClass: 'text-right text-end',
          formatter: (v, _k, item) =>
            item.hoursLabel || this.formatHoursLabel(v)
        },
        {
          key: 'amount',
          label: 'Faturamento',
          thClass: 'text-right text-end',
          tdClass: 'text-right text-end',
          formatter: (v) => this.formatBRL(v)
        }
      ]
    }
  },
  methods: {
    sum(key) {
      return this.normalized.reduce(
        (acc, cur) => acc + (Number(cur[key]) || 0),
        0
      )
    },
    formatHoursLabel(decimalHours) {
      const n = Number(decimalHours)
      if (!Number.isFinite(n)) return '0h 0min'
      const totalMinutes = Math.round(n * 60)
      const h = Math.floor(totalMinutes / 60)
      const m = totalMinutes % 60
      return `${h}h ${m}min`
    },
    formatBRL(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(n)
    }
  }
}
</script>
